const dtf = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' });
const dttf = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

const moneyFmts = new Map<string, Intl.NumberFormat>();
const moneyFmt = (currency: string) => {
  let f = moneyFmts.get(currency);
  if (!f) {
    f = new Intl.NumberFormat('pt-BR', { style: 'currency', currency });
    moneyFmts.set(currency, f);
  }
  return f;
};

export const formatDate = (iso?: string) => (iso ? dtf.format(new Date(iso)) : '—');
export const formatDateTime = (iso?: string) => (iso ? dttf.format(new Date(iso)) : '—');
/** Formata um valor monetário; `currency` é um código ISO (default BRL). */
export const formatMoney = (v?: number, currency = 'BRL') =>
  v == null ? '—' : moneyFmt(currency).format(v);
export const formatKm = (v?: number) =>
  v == null ? '—' : `${new Intl.NumberFormat('pt-BR').format(v)} km`;

export function pluralDays(n: number): string {
  return `${n} ${n === 1 ? 'dia' : 'dias'}`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
